'use client';

import { Children, PropsWithChildren, useState } from 'react';
import clsx from 'clsx';

import Button from '../ui/button';

interface ShowMoreProps extends PropsWithChildren {
  showMore: number;
  className: string;
  alwaysShow: boolean;
  inverted?: boolean;
}

const ShowMore = ({
  showMore,
  children,
  className,
  alwaysShow,
  inverted,
}: ShowMoreProps) => {
  const [expanded, setExpanded] = useState(alwaysShow);
  const [shouldAnimate, setShouldAnimate] = useState(false);
  const toggleExpanded = () => {
    if (alwaysShow) return;
    setExpanded((prev) => !prev);
    setShouldAnimate(true);
  };

  const childrenToShow = expanded
    ? children
    : Children.toArray(children).slice(0, showMore);

  const buttonClassName = clsx('items-center self-center text-center', {
    'text-white2 drop-shadow-heading hover:!text-white': inverted,
    'text-inherit hover:text-black-0': !inverted,
  });

  return (
    <>
      <div
        className={clsx(className, {
          'animate-fade-in': expanded && shouldAnimate,
        })}
      >
        {childrenToShow}
      </div>
      {!alwaysShow && (
        <div className="col-span-full flex w-full justify-center">
          <Button
            size="small"
            style="text"
            className={buttonClassName}
            type="button"
            onClick={toggleExpanded}
          >
            {expanded ? `Show Less` : `Show More`}
          </Button>
        </div>
      )}
    </>
  );
};

export default ShowMore;
